import {useId} from "vritra";
import css from "./ProduceAisle.module.css";
import ProduceBasket from "../ProduceBasket/ProduceBasket";

 
export default function ProduceAisle(props){
    const {parent,id=useId("produceaisle"),name,items}=props;
    const produceaisle=ProduceBasket({parent,id,className:css.produceaisle,items});

    produceaisle.beforeEndHTML=`
        <h3 class="${css.name}">${name}</h3>
    `;

    return produceaisle;
}
